import React from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import App from "./App";
import "./styles/tailwind.css";
import "./styles/index.css";
// NOTE: firstTouch MUST stay imported (module side effect) BEFORE React
// mounts — it reads the /r/<code> PATH form for referral first-touch
// capture before the ReferralRedirect route replace-navigates to /?ref=.
import "./utils/firstTouch";

const container = document.getElementById("root");

// Build-time prerendered marketing routes (scripts/prerender.mjs) ship with
// real HTML inside #root — hydrate it so React attaches to the existing DOM
// with no teardown/re-render flicker. Every other route (including the
// /r/:code referral redirect, /blog/:slug, portal/auth pages and 404s) is
// served the untouched SPA shell (build/spa.html → empty #root) and keeps
// the exact same client-render path as before prerendering existed.
if (container.firstElementChild) {
  hydrateRoot(container, <App />);
} else {
  const root = createRoot(container);
  root.render(<App />);
}
